import React from 'react';
import './PC.css';
import Kinsbruner from '../../img/PC/Kinsbruner.png'
import Perforce from '../../img/PC/Perforce.png'
import Lew from '../../img/PC/Lew.png'
import XBOSoft from '../../img/PC/XBOSoft.png'
import Denoo from '../../img/PC/Denoo.png'
import istqb from '../../img/PC/istqb.png'
import Kovalyova from '../../img/PC/Kovalyova.png'
import AstoundCommerce from '../../img/PC/AstoundCommerce.png'
import King from '../../img/PC/King.png'
import testai from '../../img/PC/testai.png'
import Lombard from '../../img/PC/Lombard.png'
import Provar from '../../img/PC/Provar.png'
import Harris from '../../img/PC/Harris.png'
// import Geckoboard from '../../img/PC/Geckoboard.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Kinsbruner,
          name: 'Eran Kinsbruner',
          position: 'Sr. Director, Chief Evangelist',
          ln: 'https://www.linkedin.com/in/erankinsbruner/',
          tw: 'https://twitter.com/ek121268',
          logo: Perforce,
        },
        {
          photo: Lew,
          name: 'Philip Lew',
          position: 'CEO',
          ln: 'https://www.linkedin.com/in/philiplew/',
          tw: 'https://twitter.com/philiplew',
          logo: XBOSoft,
        },
        {
          photo: Denoo,
          name: 'Olivier Denoo',
          position: 'President',
          ln: 'https://www.linkedin.com/in/olivier-denoo-2884a5/',
          logo: istqb,
        },
        {
          photo: Kovalyova,
          name: 'Oleksandra Kovalyova',
          position: 'QA Trainer Lead',
          ln: 'https://www.linkedin.com/in/alexandra-kovalyova',
          logo: AstoundCommerce,
        },
        {
          photo: King,
          name: 'Tariq King',
          position: 'Chief Scientist',
          ln: 'https://www.linkedin.com/in/tariqking',
          tw: 'https://twitter.com/tariq_king',
          logo: testai,
        },
      ],
      pcHide: [
        {
          photo: Lombard,
          name: 'Tristan Lombard',
          position: 'Director of Community',
          tw: 'https://twitter.com/TristanLombard2',
          logo: Provar,
        },
        {
          photo: Harris,
          name: 'Mike Harris',
          position: 'Tester',
          ln: 'https://www.linkedin.com/in/mike-harris-citp-mbcs-5a75733/',
          tw: 'https://twitter.com/TestAndAnalysis',
          website: 'https://testandanalysis.home.blog/',
          logo: false,
        },
      ],
      hide: true,
    }
    this.togglePC = this.togglePC.bind(this);
  }

  togglePC() {
    this.setState({ hide: !this.state.hide });
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="pc_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel='noreferrer' href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel='noreferrer' href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel='noreferrer' href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel='noreferrer' href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel='noreferrer' href={item.website}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc" id='pc'>
        <div className='container team_wrap'>
          <h2>Program committee</h2>
          <div className="pc_block">
            {this.state.pc.map((item, i) => this.renderPC(item, i))}
            {/* {!this.state.hide && this.state.pcHide.map((item, i) => this.renderPC(item, i))} */}
            {(!this.state.hide || window.innerWidth < 1200) && this.state.pcHide.map((item, i) => this.renderPC(item, i))}
          </div>
          <button className='pc_btn' onClick={this.togglePC}>{this.state.hide ? 'Show more' : 'Hide'}</button>
        </div>
      </div>
    )
  }
}